import React from "react";
import RetroContent from "./retrospectiveContent";

function RetroSection() {
	return (
		<>
			<section className="content-block" id={RetroContent.meta}>
				<h4 className="section-title-meta"> {RetroContent.meta} </h4>
				<h3 className="section-title"> {RetroContent.title} </h3>
				{RetroContent.paras.map((p) => {
					return <p>{p}</p>;
				})}
			</section>
		</>
	);
}

export default RetroSection;
